export default __webpack_public_path__ + "static/wave-billboard-desktop-white-e1f2d16c350a7abf9cd19de5c2a01596.svg";